import { Chip, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function MacroCategoryChips({ categories = [], onRemove, emptyMessage = "No categories selected." }) {
    const chips = buildChips(categories, onRemove)

    return (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ minHeight: 32 }}>
            <If truthy={chips.length > 0}>
                {chips}
                <Else>
                    <Typography variant="caption" color="text.secondary">
                        {emptyMessage}
                    </Typography>
                </Else>
            </If>
        </Stack>
    )
}

function buildChips(categories, onRemove) {
    const chips = []
    for (const category of categories) {
        chips.push(
            <Chip
                key={category}
                size="small"
                label={category}
                onDelete={onRemove ? () => onRemove(category) : undefined}
            />
        )
    }
    return chips
}
